import { useMutation, useQuery } from '@tanstack/react-query';
import { EditIcon } from 'lucide-react';
import { Link, useParams } from 'react-router-dom';
import { useSnapshot } from 'valtio';

import { DialogDeleteRecordConfirmation } from '../../../../components/pages/backoffice/dialogs/delete-record.jsx';
import DecorativeInput from '../../../../components/decorative-input.jsx';
import Error from '../../../../components/feedback/error.jsx';
import Loading from '../../../../components/feedback/loading.jsx';
import Heading from '../../../../components/typography/heading.jsx';
import { Button } from '../../../../components/ui/button.jsx';
import { Checkbox } from '../../../../components/ui/checkbox.jsx';
import FormCard from '../../../../components/ui/form-card.jsx';
import { msCatalystApi } from '../../../../services/api/ms-catalyst-api.js';
import { authState } from '../../../../services/state/auth-state.jsx';

export function ShopsShow() {
  const { isAdmin } = useSnapshot(authState);

  let { shopId } = useParams();

  const queryShop = useQuery({
    queryKey: ['shop'],
    queryFn: async () => {
      const { data: shop } = await msCatalystApi.get(`/shops/${shopId}`);

      return shop.data;
    },
  });

  const deleteShopMutation = useMutation({
    mutationFn: async () => {
      await msCatalystApi.delete(`/shops/${shopId}`);
    },
  });

  return queryShop.isLoading ? (
    <div className="flex h-[70dvh] items-center justify-center">
      <Loading />
    </div>
  ) : queryShop.isError ? (
    <Error />
  ) : (
    <>
      <div className="pb-6">
        <Heading className="pb-2">Loja</Heading>
        <h2 className="text-lg text-zinc-600 dark:text-zinc-400">
          {queryShop.data.name}
        </h2>
      </div>

      <div className="flex flex-col space-y-10">
        <div className="flex flex-col gap-5">
          <FormCard>
            <DecorativeInput value={queryShop.data.name} label="Nome" />
            <DecorativeInput value={queryShop.data.number} label="Número" />
            <DecorativeInput value={queryShop.data.type} label="Categoria" />
            <DecorativeInput
              value={queryShop.data.image}
              className="break-all"
              label="Imagem URL"
            />

            <div>
              <p className="mb-3 inline-block">Estado</p>
              <div className="flex h-10 flex-row items-center space-x-2">
                <Checkbox
                  disabled={true}
                  id="ongoing"
                  checked={queryShop.data.status}
                />
                <span className="space-y-0 text-sm">Ativa</span>
              </div>
            </div>
          </FormCard>
        </div>
      </div>

      <div className="flex flex-row flex-wrap justify-end gap-4 py-10">
        {isAdmin ? (
          <DialogDeleteRecordConfirmation
            recordName={queryShop.data.name}
            redirect="/backoffice/admin/shops"
            action={async () => deleteShopMutation.mutateAsync()}
          />
        ) : null}

        {isAdmin ? (
          <Link to={`/backoffice/admin/shops/${shopId}/edit`}>
            <Button>
              <EditIcon />
              Editar
            </Button>
          </Link>
        ) : null}
      </div>
    </>
  );
}
